import { MantineThemeComponent } from '../../types';

const ProgressDefaultConfig: MantineThemeComponent = {
	defaultProps: {
		size: 'sm'
	}
};

export default ProgressDefaultConfig;
